module.exports = __webpack_public_path__ + "img/12.d86036fa.jpg";